(function() {
    'use strict';
    //service must be lowercase since Plaid library attaches to window.Plaid
    angular.module('wbUtilities').provider('GoogleApi', [function () {

        var configDefaults = {
            clientId: null,
            scripts: [],
            scopes: ['profile', 'email']
        };
        var loaded = false;
        var promisesWaiting = [];

        /**
         * @param {Object} options
         * @param {string} options.clientId
         * @param {Array}  [options.scripts]
         * @param {Array}  [options.scopes]
         * @returns {*}
         */
        this.init = function(options) {
            angular.extend(configDefaults, options);
            configDefaults.onSuccess = function() {};
            return this;
        };

        this.$get = ['$rootScope', '$http', '$q', function($rootScope, $http, $q) {

            var googleObj = {
                gapi: null
            };

            googleObj._loadCallback = function() {
                loaded = true;
                googleObj.gapi = gapi;
                angular.forEach(promisesWaiting, function(promise) {
                    promise.resolve(googleObj.gapi);
                });
            };

            googleObj._getScriptPath = function() {
                var scripts = configDefaults.scripts.join(':');
                if (scripts) { scripts = ":" + scripts }
                return "https://apis.google.com/js/api" + scripts + ".js?onload=_GoogleApiCallback"
            };

            googleObj.getContacts = function(token) {
                return $http({
                    url: 'https://www.google.com/m8/feeds/contacts/default/full',
                    method: 'GET',
                    params: {
                        'alt': 'json',
                        'access_token': token.access_token,
                        'max-results': 9999
                    }
                }).then(function(response) {
                    var contacts = response.data.feed.entry;
                    var niceContacts = [];
                    angular.forEach(contacts, function(contact) {
                        angular.forEach(contact['gd$email'], function(email) {
                            if (!email.address) { return; }

                            var title = contact.title['$t'];
                            if (!title) {
                                title = email.address.split("@")[0];
                            }
                            niceContacts.push({
                                'email': email.address,
                                'title': title
                            });

                        });
                    });

                    return niceContacts;
                });

                // var url = "https://www.google.com/m8/feeds/contacts/default/full?access_token="+token.access_token;
                // //$sce.trustAsResourceUrl(url);
                // return $http.jsonp(url);

            };

            googleObj.initAuth = function() {
                return googleObj.getGAPI().then(function(gapi) {
                    var promiseAuth = $q.defer();
                    gapi.auth.authorize({
                        client_id: configDefaults.client_id,
                        scope: configDefaults.scopes.join(" "),
                        immediate: false
                    }, promiseAuth.resolve);
                    return promiseAuth.promise;
                });
            };

            googleObj.initAuth2 = function() {
                return googleObj.getGAPI().then(function(gapi) {
                    var promiseAuth2 = $q.defer();
                    if (!gapi.auth2) {
                        gapi.load('auth2', function() {
                            gapi.auth2.authorize({
                                client_id: configDefaults.client_id,
                                scope: configDefaults.scopes
                            }, promiseAuth2.resolve);
                        });
                    } else {
                        gapi.auth2.authorize({
                            client_id: configDefaults.client_id,
                            scope: configDefaults.scopes
                        }, promiseAuth2.resolve);
                    }
                    return promiseAuth2.promise;
                });
            };

            googleObj.initClient = function() {
                return googleObj.getGAPI().then(function(gapi) {

                });
            };

            googleObj.getPeople = function() {
                var peoplePromise = $q.defer();
                gapi.client.load('https://people.googleapis.com/$discovery/rest', 'v1', function() {
                    var request = gapi.client.people.people.connections.list({
                        'resourceName': 'people/me',
                        'requestMask': {
                            'includeField': 'person.names, person.email'
                        }
                    });
                    request.execute(function (resp) {
                        var connections = resp.connections;
                        console.log(connections);
                        peoplePromise.resolve(connections);
                    });
                });
                return peoplePromise.promise;
            };




            /**
             * Will create promises that will resolve ones GAPI is available
             * @returns {*}
             */
            googleObj.getGAPI = function() {
                if (googleObj.gapi) {
                    return $q.when(gapi);
                } else {
                    //create a new promise to be resolved when main promise is ready
                    var newPromise = $q.defer();
                    promisesWaiting.push(newPromise.promise);
                    return newPromise.promise;
                }
            };

            /**
             * Turns a manual call from gapi into an angular promise
             * @param googleThenable
             * @returns {Function|promise}
             */
            googleObj.gPromise = function(googleThenable) {
                return _wrapInAngularPromise(googleThenable);
            };

            return googleObj;


            /**
             * Wraps a googleThenable into an Angular promise
             * @param googleThenable the googleThenable
             * @returns {Function|promise} the $q promise
             * @private
             */
            function _wrapInAngularPromise(googleThenable) {
                var deferred = $q.defer();
                googleThenable.then(deferred.resolve, deferred.reject);
                return deferred.promise;
            }

        }];

        return this;

    }])

    // Initialization of module
    .run(['$window', '$document', 'GoogleApi', function ($window, $document, GoogleApi) {
        // This needs to be on the window for the callback
        $window._GoogleApiCallback = GoogleApi._loadCallback;

        var script = $document[0].createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = GoogleApi._getScriptPath();
        $document[0].body.appendChild(script);

    }]);

})();
